<div class="vertical-scroll">
  @for (item of items | async; track item) {
    <div class="slide">
      <a
        class="image-slide"
        [href]="item.link"
        target="_parent"
        [attr.aria-label]="item.title"
        >
        <div class="img" [ngStyle]="getImgStyle(item.imageUrl)">
          @if (item.type == 'Video') {
            <i class="fas fa-play"></i>
          }
        </div>
        <span [ngClass]="{ 'small-text': item.title.length > 64 }">
          {{ item.title }}
        </span>
      </a>
    </div>
  }
</div>
